module.exports = __webpack_public_path__ + "img/btn_chat_off.8b1904c5.svg";